/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DisciplineCategoryEnum {
    Standard = 'Standard',
    PracticeStage = 'PracticeStage',
    DiplomaProject = 'DiplomaProject'
}

export function DisciplineCategoryEnumFromJSON(json: any): DisciplineCategoryEnum {
    return DisciplineCategoryEnumFromJSONTyped(json, false);
}

export function DisciplineCategoryEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisciplineCategoryEnum {
    return json as DisciplineCategoryEnum;
}

export function DisciplineCategoryEnumToJSON(value?: DisciplineCategoryEnum | null): any {
    return value as any;
}

